<template>
  <div class="content" v-if="groupSelected">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
      >
        <div class="md-layout">
          <div class="md-card md-theme-default">
            <div class="md-card-header md-primary">
              <h4 class="title">
                {{ $t("dashboard.latest_inspection.title") }}
              </h4>
              <p class="category">
                {{ $t("dashboard.latest_inspection.subtitle") }}
              </p>
            </div>
            <div
              class="md-card-content"
              style="width:100%; padding-top:15px; padding-left: 0; padding-bottom:0; padding-right: 0"
            >
              <md-progress-spinner
                md-mode="indeterminate"
                v-if="recentInspectionWidget.dataLoading"
              ></md-progress-spinner>
              <div
                id="map"
                style="height: 350px"
                v-if="recentInspectionWidget.data"
              >
                <MglMap
                  :accessToken="accessToken"
                  :mapStyle="mapStyle"
                  :center="[lonCenter, latCenter]"
                  :zoom="8"
                  style="width:100%; height: 350px"
                  ref="mapboxmap"
                >
                  <MglMarker
                    v-for="marker in recentInspectionWidget.data[
                      groupSelected + '-pipescanner-inspections'
                    ]"
                    :coordinates="[marker.longitude, marker.latitude]"
                    :key="marker.id"
                  />
                </MglMap>
              </div>
            </div>
          </div>
        </div>
        <div class="md-layout">
          <div class="md-card md-theme-default">
            <div class="md-card-header md-primary">
              <h4 class="title">{{ $t("dashboard.tool_state.title") }}</h4>
              <p class="category">
                {{ $t("dashboard.tool_state.subtitle") }}
              </p>
            </div>
            <div class="md-card-content">
              <div>
                <div
                  class="md-content md-table md-theme-default"
                  value="[object Object],[object Object],[object Object],[object Object]"
                >
                  <div
                    class="md-content md-table-content md-scrollbar md-theme-default"
                  >
                    <md-progress-spinner
                      md-mode="indeterminate"
                      v-if="toolsWidget.dataLoading"
                    ></md-progress-spinner>
                    <table v-if="!toolsWidget.dataLoading">
                      <thead>
                        <tr>
                          <th class="md-table-head">
                            <div
                              class="md-table-head-container md-ripple md-disabled"
                            >
                              <div
                                class="md-table-head-label"
                                style="color: #003157"
                              >
                                {{
                                  $t("dashboard.tool_state.table_header.name")
                                }}
                              </div>
                            </div>
                          </th>

                          <th class="md-table-head">
                            <div
                              class="md-table-head-container md-ripple md-disabled"
                            >
                              <div
                                class="md-table-head-label"
                                style="color: #003157"
                              >
                                {{
                                  $t(
                                    "dashboard.tool_state.table_header.battery_state"
                                  )
                                }}
                              </div>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody v-if="toolStates">
                        <tr
                          class="md-table-row"
                          v-for="state in toolsWidget.data"
                          v-bind:key="state.name"
                        >
                          <td class="md-table-cell">
                            <div class="md-table-cell-container">
                              <strong>{{ state.id }}</strong>
                            </div>
                          </td>
                          <td class="md-table-cell" style="width:411px;">
                            <div class="md-table-cell-container">
                              <progress-bar
                                size="medium"
                                bar-color="#24e3c6"
                                style="width:100%; margin-top: 10px; display: block; margin-left: auto; margin-right: auto;"
                                :val="state.batteryNumber.toFixed(1)"
                                :text="state.batteryText"
                              ></progress-bar>
                            </div>
                            <!--
                                :val="state.battery"
                                :text="state.batteryText"
                                -->
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50"
      >
        <div class="md-layout">
          <div class="md-card md-theme-default">
            <div class="md-card-header md-primary">
              <h4 class="title">
                {{ $t("dashboard.actions_required.title") }}
              </h4>
              <p class="category">
                {{ $t("dashboard.actions_required.subtitle") }}
              </p>
            </div>
            <div class="md-card-content">
              <div>
                <md-progress-spinner
                  md-mode="indeterminate"
                  v-if="addInfoWidget.dataLoading"
                ></md-progress-spinner>
                <md-table
                  v-model="
                    addInfoWidget.data[
                      groupSelected + '-pipescanner-inspections'
                    ]
                  "
                  md-sort="date"
                  md-sort-order="asc"
                  v-if="
                    addInfoWidget.groups.includes(
                      groupSelected + '-pipescanner-inspections'
                    )
                  "
                >
                  <md-table-toolbar>
                    <h1 class="md-title">Pipescanner Inspecties</h1>
                  </md-table-toolbar>

                  <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell md-label="Inspectie datum" md-sort-by="date"
                      ><strong>{{
                        item.inspection_date
                      }}</strong></md-table-cell
                    >
                    <md-table-cell md-label="Monteur" md-sort-by="user">{{
                      item.user
                    }}</md-table-cell>
                    <md-table-cell md-label="Materiaal" md-sort-by="material">{{
                      item.material
                    }}</md-table-cell>
                    <md-table-cell md-label="Reden" md-sort-by="reason">{{
                      item.reason
                    }}</md-table-cell>
                    <md-table-cell
                      md-label="Actie"
                      v-if="permissions.includes('edit:upload')"
                      ><md-button
                        class="md-primary"
                        v-on:click="add_info(item.id)"
                        >{{
                          $t("dashboard.actions_required.table_header.button")
                        }}</md-button
                      ></md-table-cell
                    >
                  </md-table-row>
                </md-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
#map {
  position: relative;
  width: 100%;
  height: calc(100vh - 60px);
  margin-top: 0px !important;
}
.mapboxgl-ctrl-attrib-inner,
.mapboxgl-ctrl {
  display: none;
}
</style>

<script>
import ProgressBar from "vue-simple-progress";
import Mapbox from "mapbox-gl";
import { MglMap, MglMarker } from "vue-mapbox";
import axios from "axios";
import { mapState, mapMutations } from "vuex";
//require("mapbox-gl/src/css/mapbox-gl.css");
export default {
  components: { ProgressBar, MglMap, MglMarker },
  data() {
    return {
      accessToken:
        "pk.eyJ1Ijoid2VybmVyYWNxIiwiYSI6ImNqeTc1d3VrajAxazUzb255NmM5cjhuMTYifQ.Z8ZqYDJDMAuGKKCHdehiSQ", // your access token. Needed if you using Mapbox maps
      mapStyle: "mapbox://styles/mapbox/navigation-guidance-day-v4", // your map style
      centerCoordinates: [5.7918548, 53.2005936],
      uploadsAddInfo: [],
      toolStates: [],
      markers: [],
      toolsWidget: {
        dataLoading: false,
        error: null,
        data: [],
      },
      addInfoWidget: {
        dataLoading: false,
        error: null,
        data: null,
        groups: [],
      },
      recentInspectionWidget: {
        dataLoading: false,
        error: null,
        data: null,
      },
    };
  },
  computed: {
    ...mapState([
      "groupSelected",
      "apiEndpoints",
      "groupServices",
      "permissions",
      "dashboardDataTools",
      "dashboardDataMap",
    ]),
    /**
     * Computed property to set mean latitude
     * @return {float} mean value of inspections latitude
     */
    latCenter() {
      if (
        this.recentInspectionWidget.data &&
        Object.keys(this.recentInspectionWidget.data).includes(
          this.groupSelected + "-pipescanner-inspections"
        )
      ) {
        var l = this.recentInspectionWidget.data[
          this.groupSelected + "-pipescanner-inspections"
        ].length;
        return (
          this.recentInspectionWidget.data[
            this.groupSelected + "-pipescanner-inspections"
          ]
            .map((obj) => obj.latitude)
            .reduce((a, b) => {
              return a + b;
            }) / l
        );
      } else {
        return this.centerCoordinates[1];
      }
    },
    /**
     * Computed property to set mean longitude
     * @return {float} mean value of inspections latitude
     */
    lonCenter() {
      if (
        this.recentInspectionWidget.data &&
        Object.keys(this.recentInspectionWidget.data).includes(
          this.groupSelected + "-pipescanner-inspections"
        )
      ) {
        var l = this.recentInspectionWidget.data[
          this.groupSelected + "-pipescanner-inspections"
        ].length;
        return (
          this.recentInspectionWidget.data[
            this.groupSelected + "-pipescanner-inspections"
          ]
            .map((obj) => obj.longitude)
            .reduce((a, b) => {
              return a + b;
            }) / l
        );
      } else {
        return this.centerCoordinates[0];
      }
    },
  },
  watch: {
    /**
     * get the correct toolstates when switching the group
     */
    groupSelected: function(newVal) {
      this.get_tool_states();
    },
  },
  mounted() {
    //this.$auth.getTokenSilently().then((token) => {
    //  console.log(token);
    //});
    this.populate_add_info_widget();

    if (!this.dashboardDataMap) {
      this.populate_recent_inspections_widget();
    } else {
      this.recentInspectionWidget = this.dashboardDataMap;
    }
    this.get_tool_states();
  },
  methods: {
    ...mapMutations([
      "SET_SELECTED_EDIT",
      "SET_DATA_DASHBOARD_TOOLS",
      "SET_DATA_DASHBOARD_MAP",
    ]),
    /**
     * getting toolstates from api
     */
    async get_tool_states() {
      this.toolsWidget.dataLoading = true;
      var token = await this.$auth.getTokenSilently();
      var header = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      var endpoint = this.apiEndpoints.base + this.apiEndpoints.tools.states;
      axios
        .get(endpoint, header)
        .then((result) => {
          this.toolsWidget.data = result.data[this.groupSelected];
          this.toolsWidget.data.forEach((entry) => {
            //numArray.sort((a, b) => b - a);
            if (entry.states.length > 0) {
              var currentState = entry.states.sort((a, b) => b._ts - a._ts)[0];
              entry["batteryNumber"] = this.voltage_to_percentage(
                currentState.status.batteryMain
              );
              entry["batteryText"] = String(entry["batteryNumber"].toFixed(1))+ "%";
            } else {
              entry["batteryNumber"] = parseInt(100);
              entry["batteryText"] = String(entry["batteryNumber"].toFixed(1)) + "%";
            }
          });
          this.toolsWidget.dataLoading = false;
          this.SET_DATA_DASHBOARD_TOOLS(this.toolsWidget);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    /**
     * calculates battery percentage as function of voltage, forcing between 0 and 100%
     * @param {float} voltage - battery voltage from toolstate
     * @return {float} battery percentage.
     */
    voltage_to_percentage(voltage) {
      return Math.max(0, Math.min(((voltage - 3.1) / (4.1 - 3.1)) * 100, 100));
    },
    /**
     * redirect function to edit page (first selecting an inspection)
     * @param {string} id uuid of inspection
     */
    add_info(id) {
      this.SET_SELECTED_EDIT(id);
      this.$router.push("/pipescanner-edit");
    },
    /**
     * function to load/query/fill the recent inspections widget (map)
     */
    async populate_recent_inspections_widget() {
      this.recentInspectionWidget.dataLoading = true;
      var query = {
        query:
          "SELECT c.user, c.latitude, c.longitude FROM c ORDER BY c.inspection_date DESC OFFSET 0 LIMIT 10",
      };
      var token = await this.$auth.getTokenSilently();
      var header = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      var endpoint =
        this.apiEndpoints.base + this.apiEndpoints.pipescanner.custom;

      axios
        .post(endpoint, query, header)
        .then((response) => {
          //console.log(response.data);
          this.recentInspectionWidget.data = response.data;
          this.recentInspectionWidget.groups = Object.keys(response.data);
          this.recentInspectionWidget.dataLoading = false;
          this.SET_DATA_DASHBOARD_MAP(this.recentInspectionWidget);
        })
        .catch((error) => {
          this.$notify({
            message: error,
            icon: "check",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
    /**
     * function to load/query/fill the add-info widget
     */
    async populate_add_info_widget() {
      this.addInfoWidget.dataLoading = true;
      var query = {
        query:
          "SELECT c.id, c.user, c.material, c.reason, c.inspection_date FROM c WHERE NOT IS_DEFINED(c.tag) OR NOT IS_DEFINED(c.constructionyear)",
      };

      var token = await this.$auth.getTokenSilently();
      var header = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      var endpoint =
        this.apiEndpoints.base + this.apiEndpoints.pipescanner.custom;

      axios
        .post(endpoint, query, header)
        .then((response) => {
          //console.log(response.data);
          this.addInfoWidget.data = response.data;
          this.addInfoWidget.groups = Object.keys(response.data);
          this.addInfoWidget.dataLoading = false;
        })
        .catch((error) => {
          this.$notify({
            message: error,
            icon: "check",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
  },
};
</script>
